export default {
  // postするときは、基本的に以下の型
  // {
  //   "id": xxxxx
  //   "values": "xxxxx"
  // }
  object2Array: (object) => {
    return Object.entries(object).map(([key, value]) => ({
      id: Number(key),
      values: value,
    }));
  },
  // getしたときは、基本的に以下の型にして、Vue処理対応している
  // id番号 => value値（checkboxは複数回答対応のため配列、その他はstringやnumberなど）
  array2Object: (array) => {
    let object = {};
    array.forEach((item) => {
      item.input_type == 'checkbox'
        ? (object[item.id] = item.values || [])
        : (object[item.id] = item.values || '');
    });
    return object;
  },
  // @NOTE: Laravelが空オブジェクトを空配列にしてしまうため
  //        また、すでに保存されているデータがあるため、その対応処理
  array2ObjectTmpData: (array) => {
    let object = {};
    array.forEach((value, index) => {
      if (value) {
        object[index] = value;
      }
    });
    return object;
  },
  checkHiddenItems: (formData, inputData) => {
    let hiddenItems = {};
    // 親項目を持つ項目を抽出
    for (const data of Object.values(formData)) {
      for (const option of Object.values(data.options)) {
        checkInput: for (const displayItem of option.display_items.values()) {
          // 親項目が選択されていたらフラグ変更
          for (const inputItem of Object.values(inputData)) {
            if (Array.isArray(inputItem.values)) {
              const index = inputItem.values.indexOf(option.id);
              if (index >= 0) {
                hiddenItems[displayItem.item_id] = true;
                break checkInput;
              }
            } else if (
              Number.isInteger(inputItem.values) &&
              inputItem.values === option.id
            ) {
              hiddenItems[displayItem.item_id] = true;
              break checkInput;
            }
          }
          hiddenItems[displayItem.item_id] = hiddenItems[displayItem.item_id]
            ? true
            : false;
        }
      }
    }
    return hiddenItems;
  },
  excludeHiddenInput: (inputData, hiddenItems) => {
    for (const [key, val] of Object.entries(hiddenItems)) {
      if (val) continue;
      for (const key2 of Object.keys(inputData)) {
        if (key == inputData[key2].id) {
          inputData[key2].values = '';
        }
      }
    }
    return inputData;
  },
  formatDate: (date) => {
    if (null == date) {
      return '';
    }
    date = date.replace(/-/g, '/');
    var wk = new Date(date);
    return (
      wk.getFullYear() +
      '/' +
      ('0' + (wk.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + wk.getDate()).slice(-2)
    );
  },
  formatDatetime: (date) => {
    if (null == date) {
      return '';
    }
    date = date.replace(/-/g, '/');
    var wk = new Date(date);
    return (
      wk.getFullYear() +
      '/' +
      ('0' + (wk.getMonth() + 1)).slice(-2) +
      '/' +
      ('0' + wk.getDate()).slice(-2) +
      ' ' +
      wk.getHours() +
      ':' +
      ('0' + wk.getMinutes()).slice(-2)
    );
  },
  displayExpired: (datetime) => {
    if (null == datetime) {
      return '';
    }
    datetime = datetime.replace(/-/g, '/');
    const expired = new Date(datetime);
    if (expired.getTime() > Date.now()) {
      let hours = Math.abs(expired - Date.now()) / (60 * 60 * 1000);
      let intHours = parseInt(hours);
      let minutes = parseInt(hours * 60 - intHours * 60);
      if (minutes == 0) {
        return `残り${intHours}時間`;
      }
      return `残り${intHours}時間${minutes}分`;
    }
    return '期限切れ';
  },
  parseJwt: (token) => {
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function(c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );

    return JSON.parse(jsonPayload);
  },
};
